import moment from "moment";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useWorkOrdersContext } from "../../context/workOrdersContext";

// Syncs URL filter params into the reducer dataToGetWorkOrders. The work-orders
// list query refetches automatically when its key (filters) changes.
export const useSearchParamsToReducer = () => {
	const [searchParams, setSearchParams] = useSearchParams();
	const { actions } = useWorkOrdersContext();

	useEffect(() => {
		let shouldUpdate = false;

		if (searchParams.has("start")) {
			const start = searchParams.get("start");
			if (start === "") {
				searchParams.delete("start");
				shouldUpdate = true;
			}
			actions.setStartWorkOrders(moment(decodeURIComponent(start!)).toDate());
		}

		if (searchParams.has("end")) {
			const end = searchParams.get("end");
			if (end === "") {
				searchParams.delete("end");
				shouldUpdate = true;
			}
			actions.setEndWorkOrders(moment(decodeURIComponent(end!)).toDate());
		}

		if (searchParams.has("status")) {
			const status = searchParams.get("status");
			if (status !== "A" && status !== "C" && status !== "O") {
				searchParams.delete("status");
				shouldUpdate = true;
			}
			actions.setStatusCodeWorkOrders(status);
		}

		if (searchParams.has("type")) {
			const type = searchParams.get("type");
			if (type !== "A" && type !== "PM" && type !== "RM") {
				searchParams.delete("type");
				shouldUpdate = true;
			}
			actions.setTypeCodeWorkOrders(type);
		}

		if (searchParams.has("craft")) {
			const crafts = searchParams.get("craft");
			const craftNumber = Number.parseInt(crafts as string);
			if (crafts !== "A" && (isNaN(craftNumber) || craftNumber < 1)) {
				searchParams.delete("craft");
				shouldUpdate = true;
			}
			actions.setCraftIdCodeWorkOrders(Number.parseInt(crafts as string));
		}

		if (searchParams.has("search")) {
			const search = searchParams.get("search");
			if (search === "") {
				searchParams.delete("search");
				shouldUpdate = true;
			}
			actions.setSearchTextWorkOrders(search);
		} else {
			actions.setSearchTextWorkOrders("");
		}

		if (shouldUpdate) {
			setSearchParams(searchParams, { replace: true });
		}
	}, [searchParams]);
};
